import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Div from '../Div';
import Spacing from '../Spacing';
import axios from 'axios';
import { API_BASE_URL } from "../../constants";

export default function BlogDetailsPage() {
  const params = useParams();
  pageTitle('Blog');

  const [blog, setBlog] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/blog/slug/${params.blogDetailsId}`);
        // Convert ISO date format to "MM-DD-YYYY" format
        const formattedBlog = {
          ...response.data,
          dateCreated: formatDate(response.data.dateCreated),
        };
        setBlog(formattedBlog);
      } catch (error) {
        navigate("/404")
        console.error('Error fetching blogs:', error);
      }
    };

    fetchBlogs();
  }, [params.blogDetailsId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blog]);

  // Function to format date from ISO to "MM-DD-YYYY"
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()}`;
  };

  return (
    <>
      {/* Start Page Heading Section */}
      <PageHeading
        title={blog.title}
        bgSrc='/images/blog_details_hero_bg.jpeg'
        pageLinkText={params.blogDetailsId}
      />
      {/* End Page Heading Section */}

      {/* Start Blog Details */}
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-12">

            {/* Start Details Post Content */}
            <Div className="cs-post cs-style2">
              <Div className="cs-post_thumb cs-radius_15">
                <img src={blog.image} alt="Post" className="w-100 cs-radius_15" />
              </Div>
              <Div className="cs-post_info">
                <Div className="cs-post_meta cs-style1 cs-ternary_color cs-semi_bold cs-primary_font">
                  <span className="cs-posted_by">{blog.dateCreated}</span>
                  <Link to="/blog" className="cs-post_avatar">{blog.category}</Link>
                </Div>
                <h2 className="cs-post_title">{blog.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: blog.content }}></div>
              </Div>
            </Div>
            {/* End Details Post Content */}
          </Div>
          
        </Div>
      </Div>
      <Spacing lg='150' md='80'/>
      {/* Start Blog Details */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta 
          title='Let’s disscuse make <br />something <i>cool</i> together' 
          btnText='Apply For Meeting' 
          btnLink='/contact' 
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
